/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function RewindSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M16.819 4.4C16.4681 4.23901 16.0776 4.18447 15.696 4.24313C15.3144 4.30178 14.9584 4.47106 14.672 4.73L8.172 10.503C8.11046 10.5649 8.053 10.6307 8 10.7V5C8 4.73478 7.89464 4.48043 7.70711 4.29289C7.51957 4.10536 7.26522 4 7 4C6.73478 4 6.48043 4.10536 6.29289 4.29289C6.10536 4.48043 6 4.73478 6 5V19C6 19.2652 6.10536 19.5196 6.29289 19.7071C6.48043 19.8946 6.73478 20 7 20C7.26522 20 7.51957 19.8946 7.70711 19.7071C7.89464 19.5196 8 19.2652 8 19V13.3C8.05474 13.3684 8.11386 13.4332 8.177 13.494L14.677 19.267C15.0397 19.5935 15.51 19.7747 15.998 19.776C16.2829 19.7754 16.5644 19.7144 16.824 19.597C17.1765 19.4408 17.4757 19.1849 17.6847 18.8608C17.8936 18.5367 18.0032 18.1586 18 17.773V6.227C18.0034 5.84034 17.8933 5.46118 17.6834 5.13645C17.4735 4.81172 17.173 4.55567 16.819 4.4Z" fill="currentColor" />
        </svg>
    );
}
